import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

const useActivityCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axiosInstance.get(
         `${API_URL}/api/countries?populate[activities][populate][products][populate][thumbnail]=true` 
        );

        const countries = res.data?.data || [];

        // ✅ Flatten all activities safely
        const allActivities = countries.flatMap(
          (country) => country.activities || []
        );

        // ✅ Flatten all products safely
        const allProducts = allActivities.flatMap(
          (activity) => activity.products || []
        );

        // ✅ Map only top-level products
        const categoriesData = allProducts.map((product) => {
          const thumbnailUrl = product.thumbnail?.url
            ? `${product.thumbnail.url}`
            : "https://via.placeholder.com/400x250?text=No+Image";

          return {
            id: product.id,
            title: product.name || "Untitled Product",
            slug: product.slug || "",
            img: thumbnailUrl,
            isMain: true,
            rating: product.rating,
            views: product.views
          };
        });

        setCategories(categoriesData);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError("Failed to load categories. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};

export default useActivityCategories;
